import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HeaderBreadcrumbsComponent } from '@uigy/core/modules/layout/header/em-breadcrumbs/header-breadcrumbs.component';
import { HeaderComponent } from '@uigy/core/modules/layout/header/header.component';
import { MainLayoutComponent } from '@uigy/core/modules/layout/main-layout/main-layout.component';
import { NavLicenseComponent } from '@uigy/modules/license/nav-license/nav-license.component';
import {
  PcapPlayerIndicatorComponent,
} from '@uigy/modules/settings/modules/pcap-player/components/pcap-player-indicator/pcap-player-indicator.component';
import { ClockComponent, FailedPageComponent, InformativePageComponent } from '@uigy/shared/components';
import { CopyrightComponent } from '@uigy/shared/components/copyright/copyright.component';
import { DarkModeToggleComponent } from '@uigy/shared/components/dark-mode-toggle/dark-mode-toggle.component';
import { LoadingPageComponent } from '@uigy/shared/components/loading-page/loading-page.component';
import { TreeViewComponent } from '@uigy/shared/components/tree-view/tree-view.component';
import { HeaderIconComponent } from '@uigy/shared/components/icons/header-icon/header-icon.component';
import { IconComponent } from '@uigy/shared/components/icons/icon/icon.component';
import {
  UIButtonIconComponent,
} from '@uigy/shared/components/ui-button/button-icon/ui-button-icon.component';
import { AppIdDirective } from '@uigy/shared/directives/app-id/app-id.directive';
import { ClickOutsideDirective } from '@uigy/shared/directives/click-outside.directive';
import { IcpEmTagComponent } from '@uigy/shared/tag/icp-em-tag/icp-em-tag.component';
import { I18NextModule } from 'angular-i18next';
import { AboutPopupComponent } from './about-popup/about-popup.component';

import { HeaderFlyoutComponent } from './header-flyout/header-flyout.component';
import { NavigationComponent } from './navigation/navigation.component';
import { NagComponent } from '@uigy/shared/components/nag/nag/nag.component';
import { UiMenuBasicComponent } from '@uigy/shared/components/ui-menu/ui-menu-basic/ui-menu-basic.component';
import { MatTooltip } from '@angular/material/tooltip';

@NgModule({
  declarations: [
    MainLayoutComponent,
    HeaderComponent,
    NavigationComponent,
    HeaderFlyoutComponent,
    AboutPopupComponent,
    PcapPlayerIndicatorComponent,
    NavLicenseComponent,
  ],
  imports: [
    RouterModule,
    CommonModule,

    I18NextModule,
    ReactiveFormsModule,
    UIButtonIconComponent,
    ClickOutsideDirective,
    AppIdDirective,
    HeaderIconComponent,
    LoadingPageComponent,
    DarkModeToggleComponent,
    HeaderBreadcrumbsComponent,
    IcpEmTagComponent,
    CopyrightComponent,
    TreeViewComponent,
    IconComponent,
    ClockComponent,
    InformativePageComponent,
    FailedPageComponent,
    NagComponent,
    UiMenuBasicComponent,
    MatTooltip,
  ],
  exports: [
    MainLayoutComponent,
    PcapPlayerIndicatorComponent
  ]
})
export class LayoutModule {
}
